
import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";

const RegistrationSuccess = () => {
  const [progress, setProgress] = useState(0);
  const [showFinalPercentage, setShowFinalPercentage] = useState(false);

  useEffect(() => {
    const animateProgress = () => {
      setProgress(0);
      setShowFinalPercentage(false);
      const duration = 1500; // 1.5 segundos
      const interval = 10; // atualiza a cada 10ms
      const steps = duration / interval;
      const increment = 75 / steps;
      let currentProgress = 0;

      const timer = setInterval(() => {
        currentProgress += increment;
        if (currentProgress >= 75) {
          clearInterval(timer);
          setProgress(75);
          setShowFinalPercentage(true);
        } else {
          setProgress(currentProgress);
        }
      }, interval);
    };

    animateProgress();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50">
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="space-y-8 animate-fade-in">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight bg-gradient-to-r from-purple-900 to-indigo-800 bg-clip-text text-transparent text-center">
            Sua inscrição está quase completa
          </h1>

          <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-purple-800 to-indigo-700 bg-clip-text text-transparent text-center">
            Falta só mais um passo
          </h2>

          <div className="w-full bg-gray-200 rounded-full h-6 overflow-hidden shadow-inner relative">
            <div
              className="h-full bg-gradient-to-r from-purple-600 to-pink-600 transition-all duration-1500 ease-out rounded-full relative"
              style={{ width: `${progress}%` }}
            >
              <div className="absolute inset-0 flex items-center">
                <span className="text-xs font-bold text-white pl-3">0%</span>
                {showFinalPercentage && (
                  <span className="text-xs font-bold text-white absolute right-3">75%</span>
                )}
              </div>
            </div>
          </div>

          <p className="text-lg text-center text-gray-700 max-w-2xl mx-auto">
            Aperte o botão abaixo e acesse o grupo exclusivo do evento no WhatsApp para confirmar a sua participação
          </p>

          <div className="flex justify-center">
            <Button
              className="gradient-button text-lg py-6 px-8"
              onClick={() => window.open('https://growp.app/i/VOuZmb', '_blank')}
            >
              QUERO ACESSAR AGORA
            </Button>
          </div>
        </div>
      </main>

      {/* Footer - Copiado da página index */}
      <footer className="mt-2 py-8 border-t border-purple-100 bg-gradient-to-b from-transparent to-purple-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
          <div className="text-sm text-purple-600 text-center">
            <p>&copy; 2025 Maria Silvia Orlovas</p>
            <p>Todos os direitos reservados</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationSuccess;
